<template>
    <base-modal :visible="true" @close="$emit('close')" title="Create card">
        <card-form
            :loading="create.loading && create.loading"
            @cancel="$emit('close')"
            @submit="submit"/>
    </base-modal>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import CardForm from './CardForm.vue';

export default {
    name: 'CreateCardModal',
    components: { CardForm },
    props: ['space', 'flow', 'column'],
    computed: {
        ...mapState('cards', ['create']),
        ...mapState('notes', ['create']),
        ...mapGetters('topics', ['general_topic_id']),
    },
    methods: {
        async submit(data) {
            // Create new note
            const note = await this.$store.dispatch('notes/create', {
                space_id: this.space.id,
                data: { topic: this.general_topic_id, ...data },
            });

            // Create Card
            const payload = { column: this.column.id, notes: [note.id] };

            if (['open', 'close'].includes(this.column.id)) {
                data.is_open = this.column.id === 'open';
            } else {
                data.column = this.column.id;
            }

            await this.$store.dispatch('cards/create', {
                space_id: this.space.id,
                flow_id: this.flow.id,
                data: payload,
            });

            // Reload column
            await this.$store.dispatch('cards/list', {
                space_id: this.space.id,
                flow_id: this.flow.id,
                column: this.column.id,
            });

            this.$emit('close');
        },
    },
};
</script>

<style scoped>

</style>
